var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"vcita-checkbox",attrs:{"hide-details":"auto"},scopedSlots:_vm._u([(_vm.$scopedSlots.label)?{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}:null],null,true)},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }